var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-navigator',{attrs:{"page-stack":_vm.pageStack}},_vm._l((_vm.pageStack),function(page,i){return _c(page,{key:i,tag:"component",attrs:{"page-stack":_vm.pageStack}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }